import { useCallback } from 'react'
import { useParams } from 'react-router'
import {
  useAppDispatch,
  useAppSelector as useSelector,
  useAppSelector,
} from '@/state/helpers/useApp'
import * as actions from '@/state/global/global.actions'
import { type RootState } from '@/state/reducers'

const useGlobal = () => {
  const dispatch = useAppDispatch()

  const globalOrgId = useAppSelector(({ global }) => global.orgId)
  const { org_id: orgId } = useParams<{ org_id: string }>()

  const selectedReviewPageId = useSelector(
    ({ global }: RootState) => global.selectedReviewPageId
  )
  const setSelectedReviewPageId = useCallback(
    (id: string) => {
      dispatch(actions.setSelectedReviewPageId(id))
    },
    [dispatch]
  )

  const setOrgId = useCallback(
    (orgId: string) => dispatch(actions.setOrgId(orgId)),
    [dispatch]
  )

  return {
    setOrgId,
    orgId: orgId ? String(orgId) : globalOrgId,
    selectedReviewPageId,
    setSelectedReviewPageId,
  }
}

export default useGlobal
